// extracted by mini-css-extract-plugin
export default {"wrapper":"HeroBlock_wrapper__3OaRF","title":"HeroBlock_title__H87Yr","img":"HeroBlock_img__Z9Dne"};